const MAPS_SEARCH_URL = 'https://www.google.com/maps/search/?api=1&query=';

// `encodeURIComponent` rather than `encodeURI`: an address can hold `&`, `,` and `#`,
// which only the stricter encoder escapes — otherwise they terminate the query early.
export const getLocationMapsUrl = (location: string): string | null => {
  const query = location.trim();

  if (!query) {
    return null;
  }

  return `${MAPS_SEARCH_URL}${encodeURIComponent(query)}`;
};
